import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img src="/assets/logo-des-full.png" alt="D.E.S Déménagements" className="h-24 w-auto" />
            <p className="mt-6 text-neutral-400 max-w-sm leading-relaxed">
              Déménagement, Débarras et Dépannage Express. Strasbourg · Grand Est · Europe.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-4">Services</div>
            <ul className="space-y-2 text-neutral-300">
              <li>Déménagement</li>
              <li>Débarras de meubles</li>
              <li>Débarras de chantier</li>
              <li>Produits chimiques</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-4">Contact</div>
            <ul className="space-y-2 text-neutral-300">
              <li><a href="tel:0753221529" className="hover:text-[#FFB800] transition">07 53 22 15 29</a></li>
              <li><a href="mailto:depannagexpress67@gmail.com" className="hover:text-[#FFB800] transition break-all">depannagexpress67@gmail.com</a></li>
              <li>7j/7 · 8h — 20h</li>
            </ul>
            <Link
              to="/devis"
              data-testid="footer-cta-devis"
              className="mt-6 inline-flex items-center px-5 py-3 rounded-full bg-white text-black text-sm font-semibold hover:bg-[#FFB800] transition"
            >
              Devis gratuit
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} D.E.S Dépannage. Tous droits réservés.</div>
          <div className="uppercase tracking-[0.2em]">Strasbourg — France</div>
        </div>
      </div>
    </footer>
  );
}
